'use client';

import { useField } from "../internals/hooks/useField/index.mjs";
import { useTimeManager } from "../managers/index.mjs";
export const useTimeField = props => {
  const manager = useTimeManager(props);
  return useField({
    manager,
    props
  });
};